import { DateTime } from 'luxon'

import { Box } from '@domain-group/suit-theme'
import { formatDate, matchFilterBetweenDates } from '@domain-group/javascript-utils'

const dateNow = DateTime.now().toFormat('yyyy-MM-dd')

interface DateBadgeProps {
  date: string,
}

const DateBadge = (props: DateBadgeProps) => {
  const { date } = props

  const formattedDate = formatDate(date, 'dd/MM/yyyy')

  let bgcolor = 'whiteGrey'
  let color = 'bodyFontLightColor'
  let border = '1px solid'

  if (matchFilterBetweenDates(formattedDate, dateNow, dateNow)){
    bgcolor = '#61BB61'
    color = 'white'
    border = 'none'
  } else if (matchFilterBetweenDates(formattedDate, null, dateNow)){
    bgcolor = '#BB6161'
    color = 'white'
    border = 'none'
  }

  return (
    <Box
      color={color}
      display="inline-flex"
      fontSize="xxsmall"
      letterSpacing="0.5px"
      marginRight="small"
      paddingY="small"
      paddingX="medium"
      border={border}
      borderRadius={5}
      backgroundColor={bgcolor}
      borderColor="lineColor"
      width="auto"
    >
      {date}
    </Box>
  )
}

export default DateBadge
